module.exports = __webpack_public_path__ + "static/media/materials_es.7d8701d8.png";